<template>
  <SideBar />
  <div class="p-4 sm:ml-64 min-h-screen bg-gray-900 text-white">
    
    <TableComponent />
    <!-- Aquí se renderiza el componente -->
  </div>
</template>

<script>
import TableComponent from "../components/TableComponent.vue";
import SideBar from "../components/NavBar.vue";

export default {
  name: "ProductosPage",
  components: {
    TableComponent,
    SideBar, // Register the imported component here
  },
};
</script>
